import { WideWidthContainer } from "../../common/components/layout/Container";
import Heading from "../../common/components/ui/Heading";
import Paragraph from "../../common/components/ui/Paragraph";
import { BackButton, ButtonLarge } from "../../common/components/ui/buttons";
import useTrack from "../../common/hooks/useTrack";
import { useTranslation } from "react-i18next";

interface IntroToQuestionnaireCategoryProps {
  category: string;
  onBackClick: () => void;
  onContinueClick: () => void;
  visibleQuestionIndex?: number;
  nextLabel?: string;
}
const colors: { [key: string]: string } = {
  housing: "text-orange-110",
  transport: "text-purple-110",
  food: "text-pink-110",
  purchases: "text-cyan-110",
  demographic: "text-green-110",
  outro: "text-green-110",
} as const;

const image: { [key: string]: string } = {
  housing: "/images/icons/housing-white.png",
  transport: "/images/icons/transport-white.png",
  food: "/images/icons/food-white.png",
  purchases: "/images/icons/shopping-white.png",
  demographic: "/images/icons/chance-white.png",
  outro: "/images/icons/hero-white.png",
} as const;

const getStartToTranslationKey = (category: string) => {
  switch (category) {
    case "housing":
    case "transport":
    case "food":
    case "purchases":
      return `introToQuestionnaireCategory.${category}`;
    case "demographic":
      return "introToDemographic";
    case "outro":
      return "outroOfQuestionnaire";
    default:
      return "";
  }
};

export const TransitionPage: React.FC<IntroToQuestionnaireCategoryProps> = ({
  category,
  onBackClick,
  onContinueClick,
  visibleQuestionIndex,
  nextLabel,
}) => {
  const { t } = useTranslation(["intros"]);

  const isOnFirstQuestion = visibleQuestionIndex === 0;

  useTrack(category);

  const startOfTranslationKey = getStartToTranslationKey(category);

  return (
    <WideWidthContainer className="grow">
      <img
        className="grow-[3] basis-0 min-w-0 min-h-0 max-h-[400px] object-contain mx-auto shorter:hidden"
        alt=""
        src={image[category]}
      />
      <div className="flex flex-col grow gap-4 pb-4 px-4 text-center justify-between sm:justify-normal">
        <div>
          <Heading
            level={1}
            type="headline-lg-eb"
            className={`${colors[category]} pb-4`}
          >
            {t(`${startOfTranslationKey}.title`)}
          </Heading>
          <Paragraph type="body-lg">
            {t(
              `${startOfTranslationKey}.${category === "outro" ? "paragraph1" : "paragraph2"}`,
            )}
          </Paragraph>
        </div>
        <div className="flex justify-evenly gap-3 py-3.5">
          <BackButton
            onClick={isOnFirstQuestion ? undefined : onBackClick}
            size="large"
            className="text-nowrap"
          />
          <ButtonLarge
            onClick={onContinueClick}
            cyData="proceedToNext.button"
            className="w-full justify-center"
            buttonClassName="w-full"
            icon={{
              type: "ChevronRight",
              position: "right",
            }}
          >
            {nextLabel ?? t("continue", { ns: "common" })}
          </ButtonLarge>
        </div>
      </div>
    </WideWidthContainer>
  );
};
